import { render, staticRenderFns } from "./dataSummaryBase.vue?vue&type=template&id=7249ec34&scoped=true&"
import script from "./dataSummaryBase.vue?vue&type=script&lang=js&"
export * from "./dataSummaryBase.vue?vue&type=script&lang=js&"
import style0 from "./dataSummaryBase.vue?vue&type=style&index=0&id=7249ec34&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7249ec34",
  null
  
)

export default component.exports